import { css } from "@emotion/react";
import { memo, useEffect, useState } from "react";
import { useAccount, useNetwork } from "wagmi";

const ChainPopup: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { chain } = useNetwork();
  const { isConnected } = useAccount();
  const network =
    Number(process.env.REACT_APP_CHAIN_ID) === 5 ? "Goerli testnet" : "Mainnet";

  useEffect(() => {
    if (chain === undefined) {
      return;
    }
    if (isConnected && chain.id !== Number(process.env.REACT_APP_CHAIN_ID)) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [chain, isConnected]);

  return open ? (
    <div
      css={[
        css`
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.8);
        `,
      ]}
    >
      <div
        css={css`
          width: 60%;
          max-width: 400px;
          padding: 16px;
          background-color: #fff;
        `}
      >
        <div
          css={css`
            padding-bottom: 0.8em;
            text-align: center;
            text-transform: uppercase;
          `}
        >
          <h3
            css={css`
              padding-bottom: 0.4em;
              font-weight: 900;
            `}
          >
            Wrong Network Detected
          </h3>
          <p
            css={css`
              line-height: 1.2;
            `}
          >
            {`Please switch over Ethereum ${network} to be able to participate.`}
          </p>
        </div>
      </div>
    </div>
  ) : null;
};

export default memo(ChainPopup);
